import { Mail } from "lucide-react";
import { LEADERSHIP } from "../data/brands";
import { Reveal } from "./Reveal";

// Leadership profiles shown on the De Jure Group landing page.
export default function Leadership() {
  return (
    <section id="leadership" className="bg-white border-t border-dejure-silver/25" data-testid="leadership-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-36">
        <Reveal>
          <div className="border-b border-dejure-silver/30 pb-8">
            <p className="font-accent text-xs uppercase tracking-[0.25em] text-dejure-purple">
              The people behind De Jure
            </p>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-dejure-ink">
              Leadership
            </h2>
          </div>
        </Reveal>

        <div className="mt-4 grid lg:grid-cols-2">
          {LEADERSHIP.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.1}>
              <article
                data-testid={`leader-${p.name.toLowerCase()}`}
                className="group h-full border-b border-dejure-silver/25 p-8 md:p-12 lg:[&:nth-child(odd)]:border-r hover:bg-dejure-mist transition-colors duration-500"
              >
                <div className="flex items-center gap-6">
                  <img
                    src={p.photo}
                    alt={p.name}
                    data-testid={`leader-photo-${p.name.toLowerCase()}`}
                    className="h-28 w-24 shrink-0 rounded-md object-cover object-top ring-1 ring-dejure-purple/20 shadow-sm"
                  />
                  <div>
                    <h3 className="font-serif text-4xl tracking-tighter text-dejure-ink">{p.name}</h3>
                    <p className="mt-1 font-accent text-xs uppercase tracking-[0.18em] text-dejure-purple">
                      {p.role}
                    </p>
                  </div>
                </div>

                <div className="mt-10 space-y-7">
                  <Detail label="Experience" value={p.experience} />
                  <Detail label="Education" value={p.education} />
                  <Detail label="Credentials" value={p.credentials} />

                  <div className="border-t border-dejure-silver/30 pt-6">
                    <p className="font-accent text-[0.65rem] uppercase tracking-[0.2em] text-dejure-ink/40">
                      Areas of Practice
                    </p>
                    <div className="mt-4 flex flex-wrap gap-2.5">
                      {p.areas.map((a) => (
                        <span
                          key={a}
                          className="font-accent text-xs uppercase tracking-[0.1em] px-4 py-1.5 rounded-full border border-dejure-purple/25 text-dejure-ink/70"
                        >
                          {a}
                        </span>
                      ))}
                    </div>
                  </div>

                  <a
                    href={`mailto:${p.email}`}
                    data-testid={`leader-email-${p.name.toLowerCase()}`}
                    className="inline-flex items-center gap-2.5 pt-2 font-accent text-xs uppercase tracking-[0.18em] text-dejure-purple hover:text-dejure-purple-dark transition-colors duration-300"
                  >
                    <Mail size={15} />
                    {p.email}
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

function Detail({ label, value }) {
  return (
    <div className="border-t border-dejure-silver/30 pt-6">
      <p className="font-accent text-[0.65rem] uppercase tracking-[0.2em] text-dejure-ink/40">{label}</p>
      <p className="mt-3 font-sans text-sm md:text-base leading-relaxed text-dejure-ink/70">{value}</p>
    </div>
  );
}
